import { useTranslation } from "react-i18next";
import { z } from "zod";

export const MAX_QUESTION_LENGTH = 500;

export const createSupportFormSchema = (
  t: ReturnType<typeof useTranslation>["t"],
) =>
  z.object({
    email: z
      .string()
      .min(1, t("needHelp.errors.emailRequired"))
      .email(t("needHelp.errors.emailInvalid")),
    question: z
      .string()
      .min(1, t("needHelp.errors.questionRequired"))
      .max(MAX_QUESTION_LENGTH, t("needHelp.errors.questionTooLong")),
  });
